import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { memo, useMemo } from 'react';

import Menu from './components/Menu';
import type { MenuOptions } from './model';
import { MenuOptionsProvider, useMenuStore } from './store';

import { getLibraryContentQuery } from '@shared/queries/common';
import type { MenuItem } from '@shared-types/menu.types';

const App = ({
  options,
  placeholder,
}: {
  options: MenuOptions & { items: MenuItem[]; trnItem: MenuItem };
  placeholder?: ReactNode;
}) => {
  const { data: menu } = useQuery({
    ...getLibraryContentQuery<MenuItem[]>(options.libraryPath),
    enabled: !!options.libraryPath,
    placeholderData: [] as MenuItem[],
    select: (response) => ({
      trnItem: response.find((item) => item.id === 'trnname'),
      items: response.find((item) => item.id === 'mainnav')?.menuItems,
    }),
  });

  const initialState = useMemo(() => {
    if (!options.libraryPath) return { items: options.items, trnItem: options.trnItem };

    return { items: menu.items, trnItem: menu.trnItem };
  }, [menu.items, menu.trnItem, options.items, options.libraryPath, options.trnItem]);

  useMenuStore.setState(initialState);

  if (!initialState.items?.length) return <>{placeholder}</>;

  return (
    <MenuOptionsProvider options={options}>
      <Menu />
    </MenuOptionsProvider>
  );
};

export default memo(App);
